module.exports = "/_next/static/images/game-1-phone-gallery-08-23-1802-9fcbc721d2fb5684344a05e5e7b8bfac.jpg";